import styled from 'styled-components';
import { theme, toRem } from 'design';

interface IActionMenuSectionProps {
  width?: number;
  childLevel?: boolean;
  childLevelLeft?: number;
}

const ActionMenuSection = styled.section<IActionMenuSectionProps>`
  position: relative;
  flex-shrink: 0;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  border-left: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: ${theme.color.neutral[50]};

  &:first-child {
    border-left: none;
    background-color: white;
  }

  @media (min-width: ${theme.breakpoint.small}px) {
    width: ${({ width }) => toRem(width || 180)};
  }

  ${({ childLevel, childLevelLeft }) =>
    !!childLevel &&
    `
    position: absolute;
    top: 0;
    left: ${toRem(childLevelLeft || 180)};
    height: 100%;
  `}
`;

export default ActionMenuSection;
